<template>
    <div class="content-wrapper  " style="background-color:#eee ; height: 100%">

        <div class="form-group" style="margin-top: 30px">
            <a @click="$router.go(-1)" class="btn btn-default">{{ $t('Back') }}</a>
        </div>


        <CRow class="justify-content-md-center">
            <CCol sm="8">
                <CCard>
                    <form v-on:submit.prevent="saveForm()">


                        <CCardHeader>
                            <strong>ویرایش فیلد   </strong>
                            <!--                        <div class="card-header-actions">-->
                            <!--                            <a-->
                            <!--                                    href="#"-->
                            <!--                                    class="card-header-action"-->
                            <!--                                    rel="noreferrer noopener"-->
                            <!--                                    target="_blank"-->
                            <!--                            >-->
                            <!--                                <small class="text-muted">خروجی اکسل</small>-->
                            <!--                            </a>-->
                            <!--                        </div>-->
                        </CCardHeader>
                        <CCardBody>


                            <CRow>

                                <CCol sm="12">
                                    <label class="control-label">نوع فیلد</label>
                                    <select class="form-control" v-model='item.type'>
                                      <option value="input">ورودی عمومی (Input)</option>
                                      <option value="input-number">ورودی عدد (Number)</option>
                                      <option value="textarea">توضیحات (TextArea)</option>

                                      <option value="option">انتخابی (Options) </option>
                                      <option value="radio">انتخابی (Radio) </option>

                                      <option value="option-true-false">تأیید و عدم تأیید (True/False)</option>
                                      <option value="check-box">تأیید و عدم تأیید (CheckBox)</option>

                                      <option value="date">تاریخ (Date)</option>
                                      <option value="datetime">تاریخ و زمان (DateTime)</option>

                                      <option value="space">  فضای خالی (Space)</option>
                                    </select>
                                </CCol>






                                <CCol sm="12">
                                    <CInput
                                            v-model="item.title"
                                            label="عنوان فیلد"
                                            placeholder=""
                                    />
                                </CCol>


                                <!--                                <CCol sm="12">-->
                                <!--                                    <CInput-->
                                <!--                                            v-model="item.default_value"-->
                                <!--                                            label="  مقدار اولیه"-->
                                <!--                                            placeholder=""-->
                                <!--                                    />-->
                                <!--                                </CCol>-->


                              <CCol v-if="item.type === 'option' || item.type === 'radio'" sm="12">
                                <p>Options</p>

                                <table class="table table-striped table-bordered table-sm">
                                  <thead>
                                  <tr>
                                    <th scope="col">
                                      <b-btn @click="addOptions()" size="sm" variant="success">
                                        <i class="fa fa-plus"></i>
                                      </b-btn>
                                    </th>
                                    <th >عنوان</th>
                                    <th scope="col">مقدار</th>
                                    <th scope="col"></th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr v-for="(option , optionIndex) in item.options" :key="optionIndex">
                                    <th scope="row">{{optionIndex+1}}</th>
                                    <td class="pt-0">
                                      <CInput
                                          v-model="option.title"
                                          label="عنوان "
                                          placeholder=""
                                      />
                                    </td>

                                    <td  class="pt-0">
                                      <CInput
                                          v-model="option.value"
                                          label="مقدار "
                                          placeholder=""
                                      />
                                    </td>
                                    <!--                                        <td :title="">-->
                                    <!--                                            <input class="form-control form-control-sm" v-model="issueTypeField.price"-->
                                    <!--                                                   type="number" data-type="number">-->
                                    <!--                                        </td>-->

                                    <td>
                                        <span @click="deleteOptions(optionIndex)">
                                             <i class="fa fa-times"></i>
                                        </span>
                                    </td>
                                  </tr>

                                  </tbody>
                                </table>



                              </CCol>





                              <CCol sm="12" class="my-1 mb-3">

                                <multiselect   v-model="item.access_owners" :height="300" :options="roleOptions" :multiple="true"
                                               :taggable="true" :close-on-select="false" :clear-on-select="false"
                                               :custom-label="customLabelAssign"
                                               :preserve-search="true" :hide-selected="true" :show-labels="false"
                                               tag-placeholder="دسترسی" placeholder="دسترسی"
                                               label="name" track-by="name" :preselect-first="false"
                                               >

                                </multiselect>
                              </CCol>


                            </CRow>


                            <div class="row">
                                <div class="col-xs-12 form-group">
                                    <button class="btn btn-success"> {{ $t('Edit') }}</button>
                                </div>
                            </div>
                        </CCardBody>


                    </form>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>

import Multiselect from 'vue-multiselect'

    const auth = {
        headers: {
            Authorization: 'bearer ' + localStorage.getItem('token')
        }
    };


    export default {
      components: {

        Multiselect,

      },

        data: function () {
            return {
                auth: {
                    headers: {
                        Authorization: 'bearer ' + localStorage.getItem('token')
                    }
                },
                itemId: null,
                register: "",
                due: "",
                account: [],
                item: {
                    title: '',
                    type: '',
                    // options: null,
                    // default_value: '',
                    // state: ''
                },

                processeslist: [],
                errors: [],
                processes: [],
                roles: [],
              roleOptions:[],


            }
        },

        mounted() {
            let app = this;
            let id = app.$route.params.id;
            app.itemId = id;
            axios
                .get(`/api/fields/` + app.$route.params.id, auth)


                .then(function (resp) {
                    console.log('field',resp.data)

                    app.item = resp.data.data;


                  if (app.item.access_owners){
                    app.item.access_owners = JSON.parse(app.item.access_owners)
                    for (const key in  app.item.access_owners) {
                      if ( app.item.access_owners.hasOwnProperty(key)) {
                        const element =  app.item.access_owners[key];
                        app.item.access_owners[key] = {
                          name: element,
                          id: 0
                        }
                      }
                    }
                  }

                })
                .catch(function (e) {
                    for (let value of e.response.data.messages_fa) {
                        //                        for (let error of Object.entries(value[1])) {
                        //                            console.log(app.object.entries(app.errors[0]));

                        app.$snotify.warning(value, {
                            timeout: 7000,
                            //                                    showProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true
                        });

                        //                        }
                    }
                });

            // this.getProcesses()
            this.getRoles()

        },


        methods: {

          pluck(array, key) {
            return array.map(function (obj) {
              return obj[key];
            });
          },

          chanegRegister(data) {
                this.item.register_date = data
            },
            chanegdue(data) {
                this.item.due_date = data
                // console.log(this.item.due_date)
            },
            saveForm() {
                var app = this;

              if (app.item.access_owners)
                app.item.access_owners = app.pluck(app.item.access_owners , 'name')

                var newItem = app.item;


                itemId =
                    axios.patch(`/api/fields/` + app.$route.params.id, newItem, auth)


                        .then(function (resp) {
                            // console.log(resp)
                            // app.$router.push({path: '/field/list'});
                            app.$router.go(-1);


                        })
                        .catch(
                            e => {

                                app.errors.push(e.response.data.message);
                                for (let value of e.response.data.messages_fa) {
                                    //                        for (let error of Object.entries(value[1])) {
                                    //                            console.log(app.object.entries(app.errors[0]));

                                    app.$snotify.warning(value, {
                                        timeout: 7000,
                                        //                                    showProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true
                                    });

                                    //                        }
                                }

                            }

                        );
            },
            spliceNumber(number) {
                //  <input class="form-control" id="id_step2-number_2" name="step2-number_2" type="text" data-type="number">

                // $("input[data-type='number']").keyup(function (event) {
                //     var $this = $(this);
                //     var num2 = $this.val().replace(/,/gi, "").split(/(?=(?:\d{3})+$)/).join(",");
                //     $this.val(num2);
                // });
                if (number != null) {
                    return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
                }
            },
            changeBuyer() {

                var name = this.processeslist.find(x => x.id == this.item.processes_id);
                console.log(name)
                if (name)
                    this.item.buyer = name.first_name + name.last_name

            },




            getProcesses(){
                var app = this;
                axios.get('/api/intro/processes', app.auth)
                    .then(function (response) {
                        app.processes = response.data.data.data
                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },






          addOptions(){

            this.item.options.push({
              title: '',
              value: '',
            });

          },

          deleteOptions(key){

            this.item.options.splice(key,key);


          },

          getRoles(){

            axios
                .get('/admin-api/v1/role/list', this.auth)
                .then(response => {
                  this.roles = response.data.data;
                  for (const key in  this.roles) {
                    if ( this.roles.hasOwnProperty(key)) {
                      const element =  this.roles[key];
                      this.roleOptions.push({
                        name: element.name,
                        id: element.id
                      })
                    }
                  }
                })
                .catch(error => {
                    this.$snotify.warning(error.response.data.message);

                  console.log(error);
                })
                // .finally(() => this.loading = false)


          },



          customLabelAssign(option) {

            return `${option.name}`

          },

          addAssign (newTag) {

            this.roleOptions.push({
              name: newTag,
              id: 0
            })
          },




        }
    }

</script>
